import React from "react";
import tripRequestLogo from "../../assets/images/trip_request_icon.svg";
import { Link } from "react-router-dom";
import CommonHeader from "../../components/elements/CommonHeader";
import ROUTE_PATHS from "../../utils/routePaths";

const UnregisteredAircraftTripsHeader = ({ currentPage, showBackLink }) => {
  return (
    <CommonHeader
      centerLogoSrc={tripRequestLogo}
      headerText="Unregistered Aircraft Trips"
      backContent={
        <div className="navigation-header">
          <Link
            to={ROUTE_PATHS.TRIP_REQUEST_PAGE}
            state={{ currentPage }}
            className="navigation-header-link"
          >
            Home/
          </Link>
          {showBackLink ? (
            <Link
              to={ROUTE_PATHS.UNREGISTERED_AIRCRAFT_TRIPS_PAGE}
              state={{ currentPage }}
              className="navigation-header-link"
            >
              Unregistered Aircraft Trips/Details
            </Link>
          ) : (
            "Unregistered Aircraft Trips"
          )}
        </div>
      }
    />
  );
};

export default UnregisteredAircraftTripsHeader;
